import { UseFormRegister, FieldErrors } from "react-hook-form";
import { Input } from "@/components/common/Input";
import { Label } from "@/components/common/FormLabel";
import { ErrorLabel } from "@/components/common/ErrorLabel";
import { validateEmail } from "@/utils/fieldValidation";

type EmailFieldProps = {
  fieldKey: string;
  id: string;
  label?: string;
  maxLength?: number;
  isMandatory?: boolean;
  isReadOnly?: boolean;
  register: UseFormRegister<any>;
  errors: FieldErrors<any>;
};

export const EmailField = ({
  fieldKey,
  id,
  label = "Email",
  maxLength = 255,
  isMandatory = true,
  isReadOnly = false,
  register,
  errors,
}: EmailFieldProps) => {
  const rules = {
    ...(isMandatory ? { required: `${label} is required` } : {}),
    maxLength: { value: maxLength, message: `${label} must be ${maxLength} characters or less` },
    validate: (v: string) => validateEmail(v) ?? true,
  };

  return (
    <div>
      <Label
        forField={id}
        label={isMandatory ? <>{label} <span className="text-red-500">*</span></> : label}
      />
      <Input
        id={id}
        type="email"
        maxLength={maxLength}
        disabled={isReadOnly}
        inErrorState={Boolean(errors[fieldKey])}
        {...register(fieldKey, rules)}
      />
      <ErrorLabel error={errors[fieldKey]?.message as string | undefined} />
    </div>
  );
};
